import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthResetPasswordRequestBody, AuthResetPasswordResponse } from "./types";

export class ResetPasswordAPI extends BaseAPI<
    AuthResetPasswordRequestBody,
    AuthResetPasswordResponse
> {
    protected route = ApiRoutes.auth.reset_password;
    protected method = RequestMethod.POST;
    protected params = ["uid", "token"];
}